import axiosRetry from 'axios-retry';
import {
  workerAxios,
  workerResponseInterceptor,
} from '@/modules/core/app/helpers/WorkerManagerHelper';
import {
  apiAxios,
  apiLegacyAxios,
  apiRequestInterceptor,
  apiResponseInterceptor,
  apiErrorInterceptor,
  apiLegacyResponseInterceptor,
} from '@/modules/core/app/helpers/AxiosHelper';

// Register axiosRetry to retry retriable requests on Network or Idempotent request errors.
axiosRetry(apiAxios, { retryDelay: axiosRetry.linearDelay() });
axiosRetry(apiLegacyAxios, { retryDelay: axiosRetry.linearDelay() });
axiosRetry(workerAxios, { retryDelay: axiosRetry.linearDelay() });

apiAxios.interceptors.response.use(apiResponseInterceptor, apiErrorInterceptor);
apiAxios.interceptors.request.use(apiRequestInterceptor);
apiLegacyAxios.interceptors.response.use(apiLegacyResponseInterceptor);

workerAxios.interceptors.request.use(apiRequestInterceptor);
workerAxios.interceptors.response.use(workerResponseInterceptor, apiErrorInterceptor);
